/**
 * @generated SignedSource<<6deda8fc9d4b337e8274294dc539acf8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CreateDepartureLocationInput = {
  codes: ReadonlyArray<string>;
  name: string;
};
export type DepartureLocationListAddMutation$variables = {
  connections: ReadonlyArray<string>;
  input: CreateDepartureLocationInput;
};
export type DepartureLocationListAddMutation$data = {
  readonly createDepartureLocation: {
    readonly node: {
      readonly " $fragmentSpreads": FragmentRefs<"DepartureLocationListRow_departureLocation">;
    };
  };
};
export type DepartureLocationListAddMutation = {
  response: DepartureLocationListAddMutation$data;
  variables: DepartureLocationListAddMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "DepartureLocationListAddMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "DepartureLocationNode",
        "kind": "LinkedField",
        "name": "createDepartureLocation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "DepartureLocation",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "DepartureLocationListRow_departureLocation"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "DepartureLocationListAddMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "DepartureLocationNode",
        "kind": "LinkedField",
        "name": "createDepartureLocation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "DepartureLocation",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "deletable",
                    "storageKey": null
                  }
                ],
                "type": "Entity",
                "abstractKey": "__isEntity"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "appendNode",
            "key": "",
            "kind": "LinkedHandle",
            "name": "node",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              },
              {
                "kind": "Literal",
                "name": "edgeTypeName",
                "value": "DepartureLocationEdge"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e5d7875bf21be4b7393c9e34018a3c2e",
    "id": null,
    "metadata": {},
    "name": "DepartureLocationListAddMutation",
    "operationKind": "mutation",
    "text": "mutation DepartureLocationListAddMutation(\n  $input: CreateDepartureLocationInput!\n) {\n  createDepartureLocation(input: $input) {\n    node {\n      ...DepartureLocationListRow_departureLocation\n      id\n    }\n  }\n}\n\nfragment DepartureLocationListRow_departureLocation on DepartureLocation {\n  id\n  name\n  ...SortableEntityTableRow_entity\n}\n\nfragment EntityTableRow_entity on Entity {\n  __isEntity: __typename\n  id\n  deletable\n}\n\nfragment SortableEntityTableRow_entity on Entity {\n  __isEntity: __typename\n  id\n  ...EntityTableRow_entity\n}\n"
  }
};
})();

(node as any).hash = "9bcde50b08310e435ac37f8d8646c22d";

export default node;
